export default __webpack_public_path__ + "static/media/backgroud.64c784a7.svg";